module.exports = __webpack_public_path__ + "img/partners5.2dc7e317.jpg";